// Temporary ignore antd warnings in console.
// Warnings are related to antd 4.x version components and future React versions, we cannot fix antd source code
export const disableAntdFutureVersionWarnings = () => {
  // eslint-disable-next-line no-console
  const originalError = console.error;

  // eslint-disable-next-line no-console
  console.error = (...args) => {
    if (
      // eslint-disable-next-line lodash/prefer-lodash-typecheck
      typeof args[0] === 'string' &&
      args[0].includes('Support for defaultProps will be removed from function components in a future major release.')
    ) {
      return;
    }

    originalError(...args);
  };
};
